import React, { useEffect, useState, useMemo } from "react";
import { scaleLinear } from "d3-scale";
import { geoCentroid } from "d3-geo";
import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";
import _ from "lodash";
import { states } from './states';
const AreaQualifierGeoView = ({
  year
}) => {
  const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";
  const [markers, setMarkers] = useState([]);
  const [max, setMax] = useState(1);
  useEffect(() => {
    const loadData = async () => {
      const result = await fetch(`/api/lorettas/${year}/area-qualifiers/geo`);
      if (result.status > 200) {
        return;
      }
      const markers = await result.json();
      setMarkers(markers);
      const maxRiders = _.chain(markers).orderBy(x => x.count, "desc").first().value();
      setMax(maxRiders.count);
    };
    loadData();
  }, []);
  const popScale = useMemo(() => scaleLinear().domain([0, max]).range([12, 36]), [max]);
  const getGeo = (geographies, state) => {
    return geographies.find(x => x.properties.name === state);
  };
  return <ComposableMap projection="geoAlbersUsa" data-sentry-element="ComposableMap" data-sentry-component="AreaQualifierGeoView" data-sentry-source-file="area-qualifier-geo-view.jsx">
        <Geographies geography={geoUrl} data-sentry-element="Geographies" data-sentry-source-file="area-qualifier-geo-view.jsx">
            {({
        geographies
      }) => <>
                    {geographies.map(geo => <Geography key={geo.rsmKey} stroke="#FFF" geography={geo} fill="#DDD" />)}
                    {markers.map(({
          state,
          count
        }) => {
          if (!state) {
            return;
          }
          const stateData = states.find(x => x.abbreviation === state);
          if (!stateData) {
            return;
          }
          try {
            const stateFullName = stateData.name;
            const geo = getGeo(geographies, stateFullName);
            const centroid = geoCentroid(geo);
            return <Marker key={stateFullName} coordinates={centroid}>
                                    <circle fill="#F53" stroke="#FFF" r={popScale(count)} />
                                    <text y={3} textAnchor="middle" style={{
                fontFamily: "system-ui",
                fill: "#fff",
                fontSize: '.5em'
              }}>
                                        {count}
                                    </text>
                                </Marker>;
          } catch (err) {
            debugger;
            return;
          }
        })}
                </>}
        </Geographies>
    </ComposableMap>;
};
export default AreaQualifierGeoView;